import { jsx as a, jsxs as o } from "react/jsx-runtime";
import { forwardRef as B, useState as L, useMemo as f, useCallback as Y } from "react";
import { format as F } from "date-fns";
import { useDatePicker as K } from "./index.es851.js";
import { PANEL_TYPES_DICTIONARY as $, DATEPICKER_TESTID as q } from "./index.es2485.js";
import l from "./index.es5710.js";
import n from "classnames";
import { DatePickerPanel as G } from "./index.es5711.js";
import { RelativePanel as H } from "./index.es5712.js";
import { FixedPanel as J } from "./index.es5713.js";
import { DatePickerList as Q } from "./index.es5708.js";
import { Button as u } from "./index.es15.js";
import { BodyText as k } from "./index.es505.js";
const oe = B(
  ({ CTA: i, onValidateSelection: t }, U) => {
    const {
      label: y,
      activePanel: v,
      onApply: C,
      onPanelSelect: I,
      onClose: d,
      setCollapsedIsOpen: m,
      maxDate: P,
      id: M,
      selectedRangeData: s,
      variant: c,
      leftMenuRef: N,
      rightMenuRef: x,
      focusRightMenu: h,
      footerActionRefs: D
    } = K(), [p, g] = L(y || ""), E = q + M, e = f(
      () => t == null ? void 0 : t(s.value),
      [t, s.value]
    ), A = f(
      () => t ? e == null ? void 0 : e.isValid : s.value[0] !== null || s.value[1] !== null,
      [t, e == null ? void 0 : e.isValid, s.value]
    ), b = () => {
      C(s), m(!1);
    }, R = f(
      () => ({
        fixed: /* @__PURE__ */ a(J, { activePreset: p, setActivePreset: g }),
        relative: /* @__PURE__ */ a(H, { activePreset: p, setActivePreset: g }),
        "date-range": /* @__PURE__ */ a(G, {})
      }),
      [p]
    ), T = n(l.datePicker, {
      [l.collapsed]: c === "collapsed"
    }), _ = n(l.leftPanel, {
      [l.collapsed]: c === "collapsed"
    }), W = n(l.rightPanel, {
      [l.collapsed]: c === "collapsed"
    }), w = n(l.footer, {
      [l.collapsed]: c === "collapsed"
    }), z = Y(
      (r) => {
        d == null || d(r), m(!1);
      },
      [m, d]
    );
    return /* @__PURE__ */ o("div", { className: T, "data-testid": E, children: [
      /* @__PURE__ */ o(
        "div",
        {
          className: _,
          ref: N,
          role: "region",
          "aria-label": "Date picker options",
          children: [
            /* @__PURE__ */ a(
              Q,
              {
                dataSource: $,
                activeItem: v,
                onSelect: (r) => I(r, h),
                focusDateOptions: h
              }
            ),
            /* @__PURE__ */ o("div", { className: w, children: [
              i && /* @__PURE__ */ a(
                u,
                {
                  variant: "secondary-gray",
                  onClick: () => i.onClick(s),
                  fullWidth: !0,
                  testId: `${i.label}-button`,
                  children: i.label
                }
              ),
              P && /* @__PURE__ */ o("div", { className: l.note, children: [
                /* @__PURE__ */ a(k, { element: "p", isEllipsis: !0, children: "Max date:" }),
                /* @__PURE__ */ a(k, { element: "p", isEllipsis: !0, variant: "bold", children: F(new Date(P), "MMMM do") })
              ] })
            ] })
          ]
        }
      ),
      /* @__PURE__ */ o(
        "div",
        {
          className: W,
          ref: x,
          role: "region",
          "aria-label": "Date selection area",
          tabIndex: -1,
          children: [
            R[v],
            /* @__PURE__ */ o("div", { className: l.actions, children: [
              /* @__PURE__ */ a(
                u,
                {
                  variant: "secondary-gray",
                  size: "default",
                  onClick: z,
                  testId: "cancel-button",
                  fullWidth: c === "collapsed",
                  ref: (r) => D.current[0] = r,
                  children: "Cancel"
                }
              ),
              /* @__PURE__ */ a(
                u,
                {
                  variant: "primary-gray",
                  testId: "apply-date-button",
                  size: "default",
                  onClick: b,
                  disabled: !A,
                  fullWidth: c === "collapsed",
                  ref: (r) => D.current[1] = r,
                  tooltip: {
                    title: e == null ? void 0 : e.errorMsg,
                    isActive: !!t && !(e != null && e.isValid)
                  },
                  children: "Apply"
                }
              )
            ] })
          ]
        }
      )
    ] });
  }
);
export {
  oe as DatePickerMenu
};
//# sourceMappingURL=index.es854.js.map
